import Link from "next/link";
import styles from "./HoverMenu.module.css";
import { getIntlUrl as getIntlUrlUtil } from "@/utils/Common";

export default function HoverMenu({ children, listItem = [], isIntl = false }) {
  const getIntlUrl = (url) => getIntlUrlUtil(url, isIntl);
  return (
    <div className={`${styles["menu-wrap"]}`}>
      <ul className={styles.menu}>
        <li className={`${styles["menu-item"]}`} style={{ display: "flex" }}>
          {children}
          <ul className={`${styles["drop-menu"]} pt-10`}>
            {listItem.map((item, i) => (
              <Link
                href={getIntlUrl(item.url)}
                passHref={true}
                key={i}
                target={item?.openNewTab ? "_blank" : ""}
              >
                <li className={`${styles["drop-menu-item"]} hover:text-red`}>
                  {item.title}
                </li>
              </Link>
            ))}
          </ul>
        </li>
      </ul>
    </div>
  );
}
